import { render, staticRenderFns } from "./CreateLocationStructure.vue?vue&type=template&id=b929552e&scoped=true&"
import script from "./CreateLocationStructure.vue?vue&type=script&lang=js&"
export * from "./CreateLocationStructure.vue?vue&type=script&lang=js&"
import style0 from "./CreateLocationStructure.vue?vue&type=style&index=0&id=b929552e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b929552e",
  null
  
)

export default component.exports